// extracted by mini-css-extract-plugin
export default {"label":"FormField_label__yM6hJ","checkbox":"FormField_checkbox__55I0-","number":"FormField_number__UptIL","border":"FormField_border__Tj3nD","select":"FormField_select__Cagcf"};